// @flow

export { formatCashCode } from './format-cash-code';
export { cashMexicoOutgoingPaymentMapper } from './outgoing-payment-mapper';

const cashMexico = {
  dueDateFormat: 'dd/MM',
};

export default cashMexico;
